import {Box, HStack, useBreakpointValue} from "@chakra-ui/react";
import {useUser} from "../../core/hooks";
import {DesktopNav, MobileNav} from "../nav/Navbar";

const Header = () => {
    const isMobile = useBreakpointValue({base: true, '1000px': true, lg: false})
    const {user} = useUser()

    return (
        <Box
            padding={{base: 0, md: '24px 16px'}}
        >
            <HStack
                bg={'neutral.1100'}
                gap="10"
                // w={{base: "100%", md: '100%', lg: user ? '100%' : 'xl'}}
                w={'100%'}
                borderRadius={{base:0,md:'16px'}}
                px={user ? '32px' : '0'}
                m={'auto'}
                overflow={'hidden'}
                h={isMobile ? '70px' : user ? '80px' : '119px'}
                position={'relative'}>
                {isMobile ? <MobileNav user={user}/> : <DesktopNav user={user}/>}
            </HStack>
        </Box>
    )
}

export default Header